import React from 'react';
import { Button } from '@material-ui/core';
import { classNames } from '../utils/classNames';
import { getDatePresets } from '../utils/datePresets';
import { useStyles } from '../styles';
import { isSameDay } from 'date-fns';

const PresetPanel = ({ startDate, endDate, onPresetClick }) => {
    const classes = useStyles();
    const presets = getDatePresets();

    const isPresetActive = (preset) => {
        const range = preset.getRange();

        if (!range.startDate && !range.endDate) {
            return !startDate && !endDate;
        }

        if (!startDate || !endDate || !range.startDate || !range.endDate) {
            return false;
        }

        return (
            isSameDay(startDate, range.startDate) &&
            isSameDay(endDate, range.endDate)
        );
    };

    return (
        <div className={classes.presetPanel}>
            {presets.map((preset) => (
                <Button
                    key={preset.id}
                    fullWidth
                    className={classNames(classes.presetButton, {
                        [classes.presetButtonActive]: isPresetActive(preset)
                    })}
                    onClick={() => onPresetClick(preset)}
                >
                    {preset.label}
                </Button>
            ))}
        </div>
    );
};

export default PresetPanel;
